<div class="student-form-page">
  <div class="container student-form-shell">
    <section class="student-form-hero">
      <div class="student-form-hero-copy">
        <div class="student-form-badges">
          <span class="student-form-chip student-form-chip--state">Nouvel élève</span>
          <a routerLink="/students" class="student-form-chip student-form-chip--action">
            <i class="fa fa-arrow-left"></i> Retour à la liste
          </a>
        </div>

        <h1>{{ (newStudentForm.value.lastname || newStudentForm.value.firstname)
          ? ((newStudentForm.value.lastname || '') + ' ' + (newStudentForm.value.firstname || ''))
        : 'Créer un élève' }}</h1>
        <p class="student-form-subtitle">
          Coordonnées, formule et informations administratives du dossier.
          Les champs marqués d'un <span class="required">*</span> sont obligatoires.
        </p>
      </div>

      <div class="student-form-hero-actions">
        <a routerLink="/students" class="btn btn-outline-secondary">
          <i class="fa fa-times"></i> Annuler
        </a>
        <button type="submit" class="btn btn-success" form="student-create-form" [disabled]="saving">
          @if (saving) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          }
          @if (!saving) {
            <i class="fa fa-check"></i>
            } Créer l'élève
          </button>
        </div>
      </section>

      @if (studentsToCreateTotal > 0) {
        <section class="student-form-card to-create-card">
          <div class="student-form-card-head">
            <div>
              <h2>Élèves à créer <span class="to-create-count">{{ studentsToCreateTotal }}</span></h2>
              <p class="student-form-subtitle mt-1">Inscriptions en attente : vérifiez qu'un élève n'existe pas déjà avant d'en créer un nouveau.</p>
            </div>
            <button type="button" class="student-form-chip student-form-chip--action"
              [attr.aria-expanded]="showStudentsToCreate" (click)="showStudentsToCreate = !showStudentsToCreate">
              <i class="fa" [ngClass]="showStudentsToCreate ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              {{ showStudentsToCreate ? 'Masquer' : 'Afficher' }}
            </button>
          </div>
          @if (showStudentsToCreate) {
            <ul class="to-create-list">
              @for (s of studentsToCreate; track s) {
                <li tabindex="0" (click)="consultStudent(s.id)" (keydown.enter)="consultStudent(s.id)">
                  <span class="to-create-name">{{ s.lastname | uppercase }} {{ s.firstname }}</span>
                  <span class="to-create-contact">{{ s.phoneNumber || s.email }}</span>
                  @if (s.formula) {
                    <span class="to-create-formula">{{ s.formula.name }}</span>
                  }
                  <span class="to-create-date">{{ s.registrationDate | date:'dd/MM/yyyy' }}</span>
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </li>
              }
            </ul>
          }
          @if (showStudentsToCreate && studentsToCreateTotal > studentsToCreate.length) {
            <p class="to-create-more">
              {{ studentsToCreateTotal - studentsToCreate.length }} autre(s) élève(s) à créer dans la <a routerLink="/students">liste des élèves</a>.
            </p>
          }
        </section>
      }

      @if (messageError) {
        <div class="alert alert-danger student-form-alert student-form-alert--error" role="alert">
          <p class="alert-heading mb-1">Création impossible</p>
          <p class="mb-0">{{ messageError }}</p>
        </div>
      }

      @if (submited && newStudentForm.invalid) {
        <div class="alert alert-warning student-form-alert" role="alert">
          <p class="mb-0">Certains champs obligatoires sont à compléter.</p>
        </div>
      }

      <form id="student-create-form" class="student-edit-form" [formGroup]="newStudentForm" #f="ngForm" name="editEventForm"
        (ngSubmit)="isSubmited(f.form)" novalidate>
        <section class="student-form-card">
          <div class="student-form-card-head">
            <div>
              <h2>Profil</h2>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label>Civilité <span class="required">*</span></label>
              <div class="student-form-radio-group">
                <label class="student-form-radio" [class.is-invalid]="invalid('sexe')">
                  <input class="input-form" type="radio" name="sexe" formControlName="sexe" value="F">
                  <span>Madame</span>
                </label>
                <label class="student-form-radio" [class.is-invalid]="invalid('sexe')">
                  <input class="input-form" type="radio" name="sexe" formControlName="sexe" value="M">
                  <span>Monsieur</span>
                </label>
              </div>
              @if (invalid('sexe')) {
                <p class="p-alert" role="alert">Merci de choisir la civilité !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="formulaId">Formule <span class="required">*</span></label>
              <select id="formulaId" class="form-control input-form" formControlName="formulaId" [class.is-invalid]="invalid('formulaId')">
                <option [ngValue]="null" disabled>Choisir une formule</option>
                @for (f of formulas; track f) {
                  <option [ngValue]="f.id">{{ f.name }} - {{ f.price }} €</option>
                }
              </select>
              @if (invalid('formulaId')) {
                <p class="p-alert" role="alert">Merci de choisir une formule !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="neph">NEPH</label>
              <input type="text" class="form-control input-form" id="neph" formControlName="neph" placeholder="Numéro NEPH">
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="name">Nom <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="name" formControlName="lastname" placeholder="Nom"
                [class.is-invalid]="invalid('lastname')" required>
              @if (invalid('lastname')) {
                <p class="p-alert" role="alert">Merci de définir le nom !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="firstname">Prénom <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="firstname" formControlName="firstname" placeholder="Prénom"
                [class.is-invalid]="invalid('firstname')" required>
              @if (invalid('firstname')) {
                <p class="p-alert" role="alert">Merci de définir le prénom !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="birthPlace">Lieu de naissance <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="birthPlace" formControlName="birthPlace" placeholder="Lieu de naissance"
                [class.is-invalid]="invalid('birthPlace')" required>
              @if (invalid('birthPlace')) {
                <p class="p-alert" role="alert">Merci de définir le lieu de naissance !</p>
              }
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="birthDate">Date de naissance <span class="required">*</span></label>
              <input type="date" class="form-control input-form" id="birthDate" formControlName="birthDate"
                [class.is-invalid]="invalid('birthDate')" required>
              @if (invalid('birthDate')) {
                <p class="p-alert" role="alert">Merci de définir la date de naissance !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="hasCode">L'élève a eu le code <span class="required">*</span></label>
              <select id="hasCode" class="form-control input-form" formControlName="hasCode" [class.is-invalid]="invalid('hasCode')">
                <option [ngValue]="null" disabled>Choisir</option>
                <option [ngValue]="false">Non</option>
                <option [ngValue]="true">Oui</option>
              </select>
              @if (invalid('hasCode')) {
                <p class="p-alert" role="alert">Merci de définir si l'élève a eu le code !</p>
              }
            </div>

            <div class="col-md-4 mb-3">
              <label for="registrationDate">Date d'inscription</label>
              <input type="date" class="form-control input-form" id="registrationDate" formControlName="registrationDate" readonly>
            </div>
          </div>
        </section>

        <section class="student-form-card">
          <div class="student-form-card-head">
            <div>
              <h2>Coordonnées</h2>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="email">Email <span class="required">*</span></label>
              <input type="email" class="form-control input-form" id="email" formControlName="email" placeholder="Email"
                [class.is-invalid]="invalid('email')" required>
              @if (invalid('email')) {
                <p class="p-alert" role="alert">Email invalide !</p>
              }
            </div>

            <div class="col-md-6 mb-3">
              <label for="phoneNumber">Téléphone <span class="required">*</span></label>
              <input type="tel" class="form-control input-form" id="phoneNumber" formControlName="phoneNumber" placeholder="0612345678"
                maxlength="10" [class.is-invalid]="invalid('phoneNumber')" required>
              @if (invalid('phoneNumber')) {
                <p class="p-alert" role="alert">Le numéro doit contenir 10 chiffres et commencer par 0 !</p>
              }
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="address">Adresse <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="address" formControlName="address" placeholder="Adresse"
                [class.is-invalid]="invalid('address')" required>
              @if (invalid('address')) {
                <p class="p-alert" role="alert">Merci de définir l'adresse !</p>
              }
            </div>

            <div class="col-md-3 mb-3">
              <label for="postalCode">Code postal <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="postalCode" formControlName="postalCode" placeholder="Code postal"
                inputmode="numeric" maxlength="5" [class.is-invalid]="invalid('postalCode')" required>
              @if (invalid('postalCode')) {
                <p class="p-alert" role="alert">Merci de définir le code postal !</p>
              }
            </div>

            <div class="col-md-3 mb-3">
              <label for="city">Ville <span class="required">*</span></label>
              <input type="text" class="form-control input-form" id="city" formControlName="city" placeholder="Ville"
                [class.is-invalid]="invalid('city')" required>
              @if (invalid('city')) {
                <p class="p-alert" role="alert">Merci de définir la ville !</p>
              }
            </div>
          </div>
        </section>

        <section class="student-form-card">
          <div class="student-form-card-head">
            <div>
              <h2>Planning</h2>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="evalDate">Date de l'évaluation</label>
              <input type="date" class="form-control input-form" id="evalDate" formControlName="evaluationDate">
            </div>

            <div class="col-md-4 mb-3">
              <label for="evaluationHours">Nombre d'heures évaluées</label>
              <input type="number" min="0" class="form-control input-form" id="evaluationHours" formControlName="evaluationHours" placeholder="0">
            </div>

            <div class="col-md-4 mb-3">
              <label for="agreedNumberHours">Nombre d'heures convenues</label>
              <input type="number" min="0" class="form-control input-form" id="agreedNumberHours" formControlName="agreedNumberHours" placeholder="0">
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="contractDate">Date du contrat</label>
              <input type="date" class="form-control input-form" id="contractDate" formControlName="contractDate">
            </div>

            <div class="col-md-4 mb-3">
              <label for="settlementDate">Date du règlement intérieur</label>
              <input type="date" class="form-control input-form" id="settlementDate" formControlName="settlementDate">
            </div>
          </div>
        </section>

        <div class="student-form-footer">
          <button class="btn btn-primary student-form-submit" type="submit" [disabled]="saving">
            @if (saving) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            }
            Créer l'élève
          </button>
        </div>
      </form>
    </div>
  </div>
